export const getSatser = async (): Promise<StamdataNordenHelgradModel> => {
    const response = await fetch('/api/mt1535/satser/nordenhelgrad');

    if (!response.ok) {
        throw response;
    }

    return await response.json();
};

export interface StamdataNordenHelgradModel {
    SATS_ST01_MAKS_BASISSTOTTE_DAG: number;
    SATS_ST01_SKOLEPENGESTOTTE_MAKS_PER_AR_NORDEN: number;
}